import { trackEvent, trackPage } from 'lib/ui-analytics';

import { BRAND_CEL, BRAND_RCI, START_DATE } from 'contexts/CruiseSearchContext/constants';
import { INITIAL_TRACKING_BRAND, TRACKING_ACTION, TRACKING_INTERACTION } from '../Constants';

const propertyNames = {
	[BRAND_RCI.code]: {
		event: 'eventType',
		package: 'cruiseSearchPackage',
		filter: 'cruiseSearchFilter',
		type: 'cruiseSearchType',
	},
	[BRAND_CEL.code]: {
		event: 'eventType',
		package: 'search_cruise_package',
		filter: 'cruiseSearchFilter',
		type: 'Search_Type',
	},
};

export const utagEvent = (brand, initialTracking, trackingInfo, appliedDateFilter, trackingType = TRACKING_ACTION.INIT) => {
	if (trackingType === TRACKING_ACTION.INIT) {
		trackPage({ ...initialTracking });
	}

	if (trackingType === TRACKING_ACTION.SEARCH_UPDATE) {
		let filterUpdateTrackInfo = getFilterUpdateTrackInfo(trackingInfo, brand);

		if (filterUpdateTrackInfo[propertyNames[brand].filter].indexOf(START_DATE) >= 0 && appliedDateFilter !== START_DATE) {
			filterUpdateTrackInfo[propertyNames[brand].filter] = filterUpdateTrackInfo[propertyNames[brand].filter].replace(START_DATE, appliedDateFilter);
		}

		const filterUpdate = {
			...INITIAL_TRACKING_BRAND[brand],
			...trackingInfo,
			...filterUpdateTrackInfo,
		};

		trackEvent({ ...filterUpdate });
	}
};

const getFilterUpdateTrackInfo = (trackingInfo, brand) => {
	let cruiseSearchFilter = window?.location?.search?.replace('?search=', '');

	if (!cruiseSearchFilter) {
		cruiseSearchFilter = 'Any';
	}

	return {
		[propertyNames[brand].event]: 'searchOptionChange',
		[propertyNames[brand].package]: 'Any',
		[propertyNames[brand].filter]: cruiseSearchFilter,
		[propertyNames[brand].type]: trackingInfo.cruiseSearchQuery
			? TRACKING_INTERACTION.SEARCH_ORIGIN.NL_SEARCH
			: TRACKING_INTERACTION.SEARCH_ORIGIN.FILTER_UPDATE,
	};
};
